'use client'

import { useTranslations } from 'next-intl'
import useSWR from 'swr'
import { useIsClient } from 'usehooks-ts'

import ViverseButton from '@/components/ViverseButton'
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext'
import { useConfigsContext } from '@/context/ConfigsContext'
import { useToggleFollow } from '@/hooks/useToggleFollow'
import { getGuestAccount } from '@/services/cms'

function FollowButton() {
  const t = useTranslations()
  const { store, accountId } = useConfigsContext()
  const { roomData } = useCheckEnterRoomContext()
  const { isFollowed, isButtonEnabled, handleToggleFollow } = useToggleFollow()
  const isClient = useIsClient()

  const roomOwnerAccountId = roomData.owner.htc_account_id
  const htcToken = store?.credentials?.htcToken

  const { data: guestAccountData } = useSWR(
    !roomOwnerAccountId ? null : 'getGuestAccountData',
    () => getGuestAccount(htcToken!, roomOwnerAccountId).then((res) => res?.results),
  )

  const isVisitingOtherUserProfile = !!roomOwnerAccountId && accountId !== roomOwnerAccountId
  const showFollowButton = isVisitingOtherUserProfile && guestAccountData?.community_user_id

  if (!showFollowButton) {
    return null
  }

  return (
    <ViverseButton
      className="min-w-fit"
      onClick={handleToggleFollow}
      variant={isFollowed ? 'filter' : 'secondary'}
      disabled={!isButtonEnabled || !isClient}
    >
      {t(`profile-page.intro-${isFollowed ? 'unfollow' : 'follow'}-action`)}
    </ViverseButton>
  )
}

export default FollowButton
